import { createSelector } from '@ngrx/store';
import * as fromStaticDataTaxCertificates from '../static-data.reducer';
import * as TaxReducer from '../reducers/tax-certificate-type.reducer';

export const selectTaxCertificateTypes = createSelector(
  fromStaticDataTaxCertificates.selectTaxTypeState,
  TaxReducer.selectTaxCertificateType
);
